
const m = window.requirejs;
export default m;
const has = m.has;
export { has }
